import { useState } from "react";
import { Card, CardBody, Col, Nav, NavLink, Row, Spinner } from "reactstrap";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import useTrackedBestPosts from "../query/hooks/useTrackedBestPosts";
import PostCards from "./PostCards";

const TABS = [
  { label: 'Engasjement', value: 'engagement', order: false },
  { label: 'tracked_posts_tab_reach', value: 'impression', order: false },
];

/**
 * Posts from tracked accounts where one of the tenant's brands was detected.
 * Renders nothing unless the tenant has the tracked-accounts feature.
 *
 * Pass the partner selection of the surrounding dashboard:
 *  - rightsholderId / parentTenantId : PA dashboard dropdown
 *  - sponsorObjectId                 : sponsor dashboard tab
 *  - partnerId                       : club partner dashboard
 */
const TrackedAccountPosts = ({ rightsholderId, parentTenantId, sponsorObjectId, partnerId, selectedCurrency, tenant }) => {
  const { t } = useTranslation();
  const enabled = !!tenant?.features?.['tracked-accounts'];
  const [activeTab, setActiveTab] = useState(TABS[0]);

  const { data, isLoading, isPlaceholderData } = useTrackedBestPosts(activeTab, {
    rightsholderId,
    parentTenantId,
    sponsorObjectId,
    partnerId,
    enabled,
  });

  if (!enabled) {
    return null;
  }

  const posts = data?.posts ?? [];
  const loading = isLoading || isPlaceholderData;

  return (
    <Row className="mb-4">
      <Col md={12}>
        <Card className="mini-stat bg-card h-100">
          <CardBody>
            <h4 className="card-title mb-4">
              {t("tracked_posts_title")}
              {loading && <Spinner color="primary" size="sm" className="ml-2" />}
            </h4>
            <Nav pills className="navtab-bg center-pills mb-4">
              {TABS.map((tab) => (
                <NavLink
                  key={tab.value}
                  href="#"
                  className={classNames({ active: activeTab.value === tab.value })}
                  onClick={(e) => { e.preventDefault(); setActiveTab(tab); }}
                >
                  {t(tab.label)}
                </NavLink>
              ))}
            </Nav>
            <Row className="mb-4 px-4">
              <PostCards posts={posts} selectedCurrency={selectedCurrency} />
            </Row>
            {!loading && posts.length === 0 && (
              <p style={{ color: 'var(--text-secondary)' }}>{t("tracked_posts_empty")}</p>
            )}
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

const mapStateToProps = (state) => ({
  selectedCurrency: state.currency.selectedCurrency,
  tenant: state.auth.tenant,
});

export default connect(mapStateToProps)(TrackedAccountPosts);
